module.exports = __webpack_public_path__ + "static/media/12-min.fe2bade2.jpg";